import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  fulfillmentWithinFromModel,
  validateFulfillmentWithinCondition,
  type FulfillmentWithinState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FULFILLMENT_WITHIN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<FulfillmentWithinState>
  >,
): ConditionType<FulfillmentWithinState, Condition.FulfillmentPeriod> => ({
  name: "Time since fulfillment",
  description(state) {
    return `Within ${+state} days of fulfillment`;
  },
  Details(props: ConditionTypeDetailsProps<FulfillmentWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return fulfillmentWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FULFILLMENT_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state: string) {
    return validateFulfillmentWithinCondition(state).valid;
  },
});

export { type FulfillmentWithinState } from "@redotech/redo-model/return-flow/condition-validate";
